"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Renew.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Renew = function Renew(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 157.5 201.51"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Renew icon"), _react2.default.createElement("g", {
    className: "renew",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M104.68,0L0,0.15V201.51H157L157.5,54.39Zm-0.19,11.29L143.64,51.6H104.49V11.29ZM8,193.51V8.14L96.49,8V59.68l53-.08L149,193.51H8Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M111.4,79.79l-0.19,9.76A41.41,41.41,0,0,0,38.29,101.4l7.63,2.42a33.41,33.41,0,0,1,59.22-9l-8.73-.1-0.1,8L118.92,103l0.49-23Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M111.59,121.7a33.41,33.41,0,0,1-59.22,9l8.72,0.1,0.1-8-22.61-.27-0.49,23,8,0.16L46.29,136a41.41,41.41,0,0,0,72.92-11.85Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: undefined
  })));
};
exports.default = Renew;